import { useClinicSettings } from '../../lib/store/clinic-settings';
import { Switch } from "./switch";
import { Moon, Sun } from "lucide-react";

export function ModeToggle() {
  const { theme, setTheme } = useClinicSettings();
  const isDark = theme === 'dark';

  return (
    <div className="flex items-center gap-4">
      {isDark ? (
        <Moon className="h-5 w-5 text-muted-foreground" />
      ) : (
        <Sun className="h-5 w-5 text-muted-foreground" />
      )}
      <Switch
        id="theme-mode"
        checked={isDark}
        onCheckedChange={(checked) => setTheme(checked ? 'dark' : 'light')}
        className="data-[state=checked]:bg-primary"
      />
    </div>
  );
}
